/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResourcePermissionsResponse
 */
export interface ResourcePermissionsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ResourcePermissionsResponse
     */
    canView?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResourcePermissionsResponse
     */
    canManage?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResourcePermissionsResponse
     */
    canEdit?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResourcePermissionsResponse
     */
    canOperate?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResourcePermissionsResponse
     */
    canViewSensitiveFields?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ResourcePermissionsResponse
     */
    accessLevel?: string | null;
}

/**
 * Check if a given object implements the ResourcePermissionsResponse interface.
 */
export function instanceOfResourcePermissionsResponse(value: object): value is ResourcePermissionsResponse {
    return true;
}

export function ResourcePermissionsResponseFromJSON(json: any): ResourcePermissionsResponse {
    return ResourcePermissionsResponseFromJSONTyped(json, false);
}

export function ResourcePermissionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResourcePermissionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'canView': json['canView'] == null ? undefined : json['canView'],
        'canManage': json['canManage'] == null ? undefined : json['canManage'],
        'canEdit': json['canEdit'] == null ? undefined : json['canEdit'],
        'canOperate': json['canOperate'] == null ? undefined : json['canOperate'],
        'canViewSensitiveFields': json['canViewSensitiveFields'] == null ? undefined : json['canViewSensitiveFields'],
        'accessLevel': json['accessLevel'] == null ? undefined : json['accessLevel'],
    };
}

export function ResourcePermissionsResponseToJSON(json: any): ResourcePermissionsResponse {
    return ResourcePermissionsResponseToJSONTyped(json, false);
}

export function ResourcePermissionsResponseToJSONTyped(value?: ResourcePermissionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'canView': value['canView'],
        'canManage': value['canManage'],
        'canEdit': value['canEdit'],
        'canOperate': value['canOperate'],
        'canViewSensitiveFields': value['canViewSensitiveFields'],
        'accessLevel': value['accessLevel'],
    };
}

